import {
  ReactElement,
  useCallback,
  useMemo,
  ReactNode,
  useState,
  ChangeEvent,
  FormEvent,
} from 'react';
import {Link} from '@shopify/hydrogen';
import {LoginWithEmailPayloadType} from '../../backendApi';
import {useAuthService} from '../../contexts/AuthServiceProvider.client';
import SocialAuthBlock from '../SocialAuthBlock.client';
import {GoogleOAuthProvider} from '@react-oauth/google';
import {config} from '../../config';

export default function LoginForm(): ReactElement {
  const [formFields, setFormFields] = useState<LoginWithEmailPayloadType>({
    email: '',
    password: '',
  });

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const {name, value} = e.target;
    setFormFields((prevState) => ({...prevState, [name]: value}));
  };

  const {handleLoginWithEmail, error} = useAuthService();

  const handleFormSubmit = useCallback(
    (e: FormEvent) => {
      e.preventDefault();
      handleLoginWithEmail(formFields);
    },
    [handleLoginWithEmail, formFields],
  );

  const errorBlock = useMemo((): ReactNode => {
    if (typeof error === 'string') {
      return <span style={{color: '#f73400'}}>{error}</span>;
    } else if (typeof error === 'object') {
      return (
        <ul style={{listStyle: 'none'}}>
          {Object.keys(error).map((key) => (
            <li key={key} style={{color: '#f73400'}}>
              {error[key]}
            </li>
          ))}
        </ul>
      );
    }
  }, [error]);

  return (
    <>
      <div className="login-form-outer">
        <h2 className="title-2">Log in to your Whisky Lover account</h2>
        <div className="login-form">
          <GoogleOAuthProvider clientId={config.googleOauth2ClientId}>
            <SocialAuthBlock />
          </GoogleOAuthProvider>
          <form onSubmit={handleFormSubmit}>
            <div className="signup__form form">
              {errorBlock}
              <div className="form__row row">
                <label className="col-md-12">
                  <input
                    type="email"
                    name="email"
                    value={formFields?.email}
                    onChange={handleChange}
                    className="form__element"
                    placeholder="Email"
                    required
                  />
                </label>
              </div>
              <div className="form__row row">
                <label className="col-md-12">
                  <input
                    type="password"
                    name="password"
                    value={formFields?.password}
                    onChange={handleChange}
                    className="form__element"
                    placeholder="Password"
                    required
                  />
                </label>
              </div>
              <div className="form__row row signup__submit">
                <div className="col-md-12">
                  <button
                    type="submit"
                    className="button button_form button_full button_size_large"
                    disabled={false}
                  >
                    Login
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
        <Link to="/forgot-password" className="forgot-password u-hover">
          Forgot your password?
        </Link>
      </div>
      <div className="form__row signup__already">
        Don&apos;t have a Whisky Lover account?&nbsp;
        <Link to="/signup" className="u-hover">
          Sign up here
        </Link>
      </div>
    </>
  );
}
